var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBonus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04878 9V17H2.95122C2.30556 17 1.78049 16.4618 1.78049 15.8V8.9596C1.90654 8.986 2.03707 9 2.17073 9H7.04878ZM7.82927 9V17H10.1707V9H7.82927ZM15.8293 9H10.9512V17H15.0488C15.6944 17 16.2195 16.4618 16.2195 15.8V8.9596C16.0935 8.986 15.9629 9 15.8293 9ZM17 5.4V7C17 7.6618 16.4749 8.2 15.8293 8.2H2.17073C1.52507 8.2 1 7.6618 1 7V5.4C1 4.7382 1.52507 4.2 2.17073 4.2H5.88176C5.63571 3.8652 5.4878 3.4504 5.4878 3C5.4878 1.8972 6.36312 1 7.43902 1C8.07766 1 8.6439 1.3176 9 1.8052C9.35629 1.3176 9.92234 1 10.561 1C11.6369 1 12.5122 1.8972 12.5122 3C12.5122 3.4504 12.3643 3.8652 12.1182 4.2H15.8293C16.4749 4.2 17 4.7382 17 5.4ZM9.39024 3V4.2H10.561C11.2066 4.2 11.7317 3.6618 11.7317 3C11.7317 2.3382 11.2066 1.8 10.561 1.8C9.91532 1.8 9.39024 2.3382 9.39024 3ZM7.43902 4.2H8.60976V3C8.60976 2.3382 8.08468 1.8 7.43902 1.8C6.79337 1.8 6.26829 2.3382 6.26829 3C6.26829 3.6618 6.79337 4.2 7.43902 4.2Z",
    fill: "#7D7DF7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBonus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bonus.b9701a3d.svg";
export { ForwardRef as ReactComponent };